const getOfferType = (
  typeId: string | undefined,
  type: string | undefined
): string => {
  if (type !== undefined) {
    return type;
  }
  if (typeId === '0') {
    return 'offer';
  }
  if (typeId === '1') {
    return 'preliminary-offer';
  }
  if (typeId === '2') {
    return 'additional-offer';
  }
  if (typeId === '3') {
    return 'material-offer';
  }
  if (typeId === '4') {
    return 'cost-estimate';
  }
  if (typeId === '5') {
    return 'opportunity';
  }
  return '';
};

export default getOfferType;
